import { Container } from "../shared/Container"
import { Title } from "../shared/Title"

const logos = ["SVH"]

export const Brands = () => {
  return (
    <section>
      {" "}
      <Container className="space-y-8">
        <div className="mx-auto max-w-3xl text-center">
          <Title> Used By </Title>
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          {logos.map((logo, key) => (
            <div key={key} className="bg-body border-box-border group rounded-xl border p-4 sm:p-5">
              <img
                src={`/assets/logos/${logo}.png`}
                width="100"
                height="60"
                alt={logo}
                className="h-7 w-auto grayscale duration-300 ease-linear group-hover:scale-105 group-hover:!grayscale-0 sm:h-10"
              />
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
